import { useEffect, useState, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import ContactMap from "../sub-map/ContactMap"

// API
import axios from 'axios';

function Contact() {
    // INQUIRY
    let [content, setContent] = useState();
    let [optionItem, setOptionItem] = useState();
    let [input1, setInput1] = useState();
    let [input2, setInput2] = useState();
    let [input3, setInput3] = useState();
    let [input4, setInput4] = useState();
    let [agreement, setAgreement] = useState();
    let [popUp, setPopUp] = useState("");
    let [warning, setWarning] = useState("");

    // useEffect(()=>{
    //     setOptionItem(optionItem.replace(/&/g,"%26"))
    //     // optionItem = optionItem.replace(/&/g,"%26");
    // },[optionItem])
    


    function inquiryEnroll() {
        axios.post("https://api.bio3s.com/api/register?name=" + input1 + " &company= " + input2 + " &phone= " + input3 + " &email= " + input4 + " &category= " + optionItem + " &content=" + content ).then((response) => {
            console.log(response);
        })
        .catch((error) => {
            console.log(error.response);
        });
    }

    useEffect(()=>{
        /* selectBox */
        const label = document.querySelector('.label');
        const options = document.querySelectorAll('.optionItem');
        // 클릭한 옵션의 텍스트를 라벨 안에 넣음
        const handleSelect = function(item) {
        label.innerHTML = item.textContent;
        label.parentNode.classList.remove('active');
        }
        // 옵션 클릭시 클릭한 옵션을 넘김
        options.forEach(function(option){
        option.addEventListener('click', function(){handleSelect(option)})
        })
        // 라벨을 클릭시 옵션 목록이 열림/닫힘
        label.addEventListener('click', function(){
        if(label.parentNode.classList.contains('active')) {
            label.parentNode.classList.remove('active');
        } else {
            label.parentNode.classList.add('active');
        }
        });
    },[])

    return (
        <div className='Contact customer-enquiry'>
            <ContactMap tag2={"고객문의"}></ContactMap>
            <div className='sub-con'>
                <div className='section1'>
                    <div className='container'>
                        <h3 className='h3-st2'>고객문의</h3>
                        <div className='way-wrap'>
                            <div>
                                <span className='icon'><i className='xi-call'></i></span>
                                <span className='txt'>대표번호</span>
                                <p>1899-5397</p>
                            </div>
                            <div>
                                <span className='icon'><i className='xi-mail'></i></span>
                                <span className='txt'>이메일</span>
                                <p>contact@bio3s.com</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='section2'>
                    <div className='container'>
                        <div className='top-wrap'>
                            <span className='q-box'>Q</span>
                            <p>문의내용을 입력해 주세요</p>
                        </div>
                        <div className="selectBox2">
                            <button className="label">문의 분류를 선택해 주세요 <i className='xi-caret-down'></i></button>
                            <ul className="optionList">
                                <li className="optionItem" onClick={()=>{setOptionItem(encodeURIComponent("R&D(연구&개발)"))}}>R&D(연구&개발)</li>
                                <li className="optionItem" onClick={()=>{setOptionItem(encodeURIComponent("노로-X 손세정제 거품비누형"))}}>노로-X 손세정제 거품비누형</li>
                                <li className="optionItem" onClick={()=>{setOptionItem(encodeURIComponent("코록스 손소독제"))}}>코록스 손소독제</li>
                                <li className="optionItem" onClick={()=>{setOptionItem(encodeURIComponent("빈가드가글 플러스"))}}>빈가드가글 플러스</li>
                                <li className="optionItem" onClick={()=>{setOptionItem(encodeURIComponent("빈가드 시린이 치약"))}}>빈가드 시린이 치약</li>
                                <li className="optionItem" onClick={()=>{setOptionItem(encodeURIComponent("빈가드 과일채소세척제"))}}>빈가드 과일채소세척제</li>
                                <li className="optionItem" onClick={()=>{setOptionItem(encodeURIComponent("빈가드 V-CARE 스프레이"))}}>빈가드 V-CARE 스프레이</li>
                                <li className="optionItem" onClick={()=>{setOptionItem(encodeURIComponent("기타"))}}>기타</li>
                            </ul>
                        </div>
                        <textarea name="" id="txt" placeholder='문의내용을 입력해 주세요' onChange={()=>{
                            setContent(document.getElementById('txt').value);
                            console.log(content);
                        }}></textarea>
                        <div className='top-wrap'>
                            <span className='q-box'>Q</span>
                            <p>상담을 위한 개인정보를 입력해 주세요</p>
                        </div>
                        <div className='question-wrap'>
                            <div className='ipt-wrap'>
                                <span>문의자명</span>
                                <input id='input1' type="text" placeholder='문의자명을 입력해 주세요.' onChange={()=>{
                                    setInput1(document.getElementById('input1').value);
                                    console.log(input1);
                                }} />
                            </div>
                            <div className='ipt-wrap'>
                                <span>회사명</span>
                                <input id='input2' type="text" placeholder='회사명을 입력해 주세요.' onChange={()=>{
                                    setInput2(document.getElementById('input2').value);
                                    console.log(input2);
                                }} />
                            </div>
                            <div className='ipt-wrap'>
                                <span>연락처</span>
                                <input id='input3' type="text" placeholder='문의자 연락처를 입력해 주세요.' onChange={()=>{
                                    setInput3(document.getElementById('input3').value);
                                    console.log(input3);
                                }} />
                            </div>
                            <div className='ipt-wrap'>
                                <span>이메일</span>
                                <input id='input4' type="text" placeholder='문의자 이메일을 입력해 주세요.' onChange={()=>{
                                    setInput4(document.getElementById('input4').value);
                                    console.log(input4);
                                }} />
                            </div>
                            <div className='ck-wrap'>
                                <input type="checkbox" name="" id="agreement" className='ck-input' />
                                <label htmlFor="agreement" className='ck-label' onClick={()=>{
                                    if (document.getElementById('agreement').checked == true) {
                                        setAgreement(false);
                                        console.log(agreement);
                                    }else{
                                        setAgreement(true);
                                        console.log(agreement);
                                    }
                                }}>
                                    <span><i className='xi-check-min'></i></span>
                                    <p>개인정보 수집 및 이용 동의(필수)</p>
                                </label>
                                <a href='/PersonalNformation' target='_blank' rel='noreferrer'>전문보기</a>
                            </div>
                        </div>
                        <button className="btn-st1" onClick={()=>{
                            if (!content || !optionItem || !input1 || !input2 || !input3 || !input4 || !agreement) {
                                console.log("내용없음");
                                setWarning(" on");
                            }else{
                                console.log("내용있음");
                                setWarning("");
                                setPopUp(" open");
                                inquiryEnroll();
                            }
                        }}>문의등록</button>
                        <p className={'warning' + warning}>내용을 모두 입력해주세요</p>
                        <div className={'pop-wrap' + popUp}>
                            <div className='pop-box'>
                                <i className='xi-check-circle'></i>
                                <span>등록완료</span>
                                <p>고객문의 등록이 완료되었습니다.<br/>
                                    문의하신 사항해 대해 정확히 확인한 후 빠르게<br/>
                                    답변 드리도록 하겠습니다. 감사합니다.</p>
                                <button onClick={()=>{window.location.reload()}} className='close-btn'>닫기</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Contact;